import { HirerTeamMemberSendEmailForm } from '@seek/hirer-team-member-job-access';
import { useTranslations } from '@vocab/react';
import { Stack, Text } from 'braid-design-system';

import translations from './.vocab';

interface Props {
  jobTitle?: string;
  jobId?: string;
  userName?: string;
}
export const TeamMemberEmail = ({
  jobTitle = '',
  jobId = '',
  userName = '',
}: Props) => {
  const { t } = useTranslations(translations);
  return (
    <Stack space="medium">
      <Text weight="strong">{t('Email your team members. They...')}</Text>

      <HirerTeamMemberSendEmailForm
        id="team-members-email"
        senderFirstName={userName}
        jobId={jobId}
        jobTitle={jobTitle}
        senderLastName=""
      />
    </Stack>
  );
};
